import { Link } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';

const Info = () => {
  const [formData, setFormData] = useState({
    username: '',
    name: '',
    password: '',
    password2: '',
    nickname: '',
    rrn_prefix: '',
    rrn_digit: '',
    mobile_carrier: '',
    phone_number: '',
    verification_code: '',
    trading_bank: '',
    account_number: '',
    entered_referral_code: '',
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });

    // const { name, value } = e.target;

    // if (name === "rrn_prefix") {
    //     // Allow both formats: YYMMDD or YYYY-MM-DD
    //     // If user is typing a date in YYYY-MM-DD format
    //     if (value === "" || /^\d{0,4}(-\d{0,2})?(-\d{0,2})?$/.test(value)) {
    //         setFormData({ ...formData, [name]: value });
    //     }
    //     // If user is typing 6 digits for YYMMDD format
    //     else if (/^\d{0,6}$/.test(value)) {
    //         // Convert to YYYY-MM-DD format if it's 6 digits
    //         if (value.length === 6) {
    //             const year = value.substring(0, 2);
    //             const month = value.substring(2, 4);
    //             const day = value.substring(4, 6);

    //             // For years 00-24, assume 2000s, otherwise 1900s
    //             const fullYear = parseInt(year) < 25 ? `20${year}` : `19${year}`;

    //             setFormData({ ...formData, [name]: `${fullYear}-${month}-${day}` });
    //         } else {
    //             setFormData({ ...formData, [name]: value });
    //         }
    //     }
    // } else if (name === "rrn_digit") {
    //     // Allow only one digit (0-9)
    //     const regex = /^[0-9]?$/;
    //     if (regex.test(value)) {
    //         setFormData({ ...formData, [name]: value });
    //     }
    // } else {
    //     setFormData({ ...formData, [name]: value });
    // }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
    setError('');
    setSuccess('');

    try {
      const csrfToken = 'EdK5PAvTRvWEyRdfznMVSS44tKmYub0PIcqlchfULJqZ07LYacmeBe8iWH3MYOQQ'; // Replace this or fetch it dynamically if needed

      const response = await axios.post('https://api.1000siljang.xyz/api/users/signup', formData, {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFTOKEN': csrfToken,
        },
      });

      setSuccess('Registration successful!');
      console.log(response.data);
    } catch (err) {
      console.error(err);
      setError('Registration failed. Please check your fields.');
    }
  };

  return (
    <>
      <section className="info-section bg-black min-h-screen w-full pb-5 pt-[20px] lg:pt-[50px]">
        <div className="max-w-[320px] md:max-w-[600px] lg:max-w-[800px] my-5 lg:my-0 mx-auto p-5 rounded-[5px] lg:rounded-[10px] bg-[#00000088] lg:bg-charcoal lg:border lg:border-indigoBlue shadow-[0px_0px_10px_#01278f,_0px_0px_30px_#2782f2] lg:shadow-[0_2px_3px_#000000b3] backdrop-blur-[10px] lg:backdrop-blur-[0px]">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="lg:p-2.5 lg:h-[105px]">
              <label
                htmlFor="username"
                className="mb-[5px] mt-2.5  lg:mb-2.5 lg:m-2.5 block text-[12.9px] lg:text-base text-skyblue lg:text-white "
              >
                {' '}
                아이디
              </label>
              <div className="">
                <input
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  type="text"
                  className="text-white bg-black lg:bg-obsidian text-xs lg:text-sm leading-10 h-10 transition-[0.2s] align-middle block text-center lg:text-left w-full lg:w-[98%] lg:mx-[1%] my-[5px] py-0.5 px-[5px] lg:p-[5px] lg:rounded-[5px] border border-navyBlue lg:border-slate focus:border-skyblue lg:focus:border-indigoBlue outline-none"
                  placeholder="아이디입력"
                />
                <small className="text-[#FF5757] lg:text-crimson text-[10px] lg:hidden">
                  영문자, 숫자, _ 만 입력하세요.
                </small>
                <br />
                <small className="text-white text-[10px] lg:hidden">
                  - 영문 소문자, 숫자만 입력 가능하며 최소 3자 이상 입력하세요.
                </small>
                <small className="text-crimson text-[80%] hidden lg:block"></small>
              </div>
            </div>
            <div className="lg:p-2.5 lg:h-[105px]">
              <label
                htmlFor="name"
                className="mb-[5px] mt-2.5  lg:mb-2.5 lg:m-2.5 block text-[12.9px] lg:text-base text-skyblue lg:text-white"
              >
                {' '}
                이름
              </label>
              <div className="">
                <input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  type="text"
                  className="text-white bg-black lg:bg-obsidian text-xs lg:text-sm leading-10 h-10 transition-[0.2s] align-middle block text-center lg:text-left w-full lg:w-[98%] lg:mx-[1%] my-[5px] py-0.5 px-[5px] lg:p-[5px] lg:rounded-[5px] border border-navyBlue lg:border-slate focus:border-skyblue lg:focus:border-indigoBlue outline-none"
                  placeholder="예금주와 동일명"
                />

                <small className="text-[10px] lg:hidden">
                  - 실명이 아닌 경우에 환전시 불이익을 받을 수 있습니다.(공백없이 한글만 입력 가능)
                </small>
                <small className="text-crimson text-[80%]"></small>
              </div>
            </div>
            <div className="lg:p-2.5 lg:h-[105px]">
              <label
                htmlFor="password"
                className="mb-[5px] mt-2.5  lg:mb-2.5 lg:m-2.5 block text-[12.9px] lg:text-base text-skyblue lg:text-white "
              >
                {' '}
                패스워드
              </label>
              <div className="">
                <input
                  name="password"
                  type="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="text-white bg-black lg:bg-obsidian text-xs lg:text-sm leading-10 h-10 transition-[0.2s] align-middle block text-center lg:text-left w-full lg:w-[98%] lg:mx-[1%] my-[5px] py-0.5 px-[5px] lg:p-[5px] lg:rounded-[5px] border border-navyBlue lg:border-slate focus:border-skyblue lg:focus:border-indigoBlue outline-none"
                  placeholder="패스워드"
                />
                <small className="text-crimson text-[80%]"></small>
              </div>
            </div>
            <div className="lg:p-2.5 lg:h-[105px]">
              <label
                htmlFor="password2"
                className="mb-[5px] mt-2.5  lg:mb-2.5 lg:m-2.5 block text-[12.9px] lg:text-base text-skyblue lg:text-white "
              >
                {' '}
                패스워드확인
              </label>
              <div className="">
                <input
                  name="password2"
                  type="password"
                  value={formData.password2}
                  onChange={handleChange}
                  className="text-white bg-black lg:bg-obsidian text-xs lg:text-sm leading-10 h-10 transition-[0.2s] align-middle block text-center lg:text-left w-full lg:w-[98%] lg:mx-[1%] my-[5px] py-0.5 px-[5px] lg:p-[5px] lg:rounded-[5px] border border-navyBlue lg:border-slate focus:border-skyblue lg:focus:border-indigoBlue outline-none"
                  placeholder="패스워드 확인"
                />
                <small className="text-crimson text-[80%]"></small>
              </div>
            </div>
            <div className="lg:p-2.5 lg:h-[105px]">
              <label
                htmlFor="nickname"
                className="mb-[5px] mt-2.5  lg:mb-2.5 lg:m-2.5 block text-[12.9px] lg:text-base text-skyblue lg:text-white "
              >
                {' '}
                별명
              </label>
              <div className="">
                <input
                  name="nickname"
                  value={formData.nickname}
                  onChange={handleChange}
                  type="text"
                  className="text-white bg-black lg:bg-obsidian text-xs lg:text-sm leading-10 h-10 transition-[0.2s] align-middle block text-center lg:text-left w-full lg:w-[98%] lg:mx-[1%] my-[5px] py-0.5 px-[5px] lg:p-[5px] lg:rounded-[5px] border border-navyBlue lg:border-slate focus:border-skyblue lg:focus:border-indigoBlue outline-none"
                  placeholder="별명입력"
                />
                <small className="text-white text-[10px] lg:hidden">
                  - 공백없이 한글, 영문, 숫자만 입력가능합니다.(4자이상)
                </small>
                <small className="text-[#ff0000] text-[80%]"></small>
              </div>
            </div>
            <div className="lg:p-2.5 lg:h-[105px]">
              <label
                htmlFor="rrn_prefix"
                className="mb-[5px] mt-2.5  lg:mb-2.5 lg:m-2.5 block text-[12.9px] lg:text-base text-skyblue lg:text-white "
              >
                {' '}
                생년월일
              </label>
              <div className="">
                <input
                  name="rrn_prefix"
                  value={formData.rrn_prefix}
                  onChange={handleChange}
                  type="text"
                  className="w-full lg:w-[40%] text-white bg-black lg:bg-obsidian text-xs lg:text-sm leading-10 h-10 transition-[0.2s] align-middle inline-block text-center lg:text-left lg:mx-[1%] my-[5px] py-0.5 px-[5px] lg:p-[5px] lg:rounded-[5px] border border-navyBlue lg:border-slate focus:border-skyblue lg:focus:border-indigoBlue outline-none"
                  placeholder="YYYY-MM-DD 형식"
                />
                <span> - </span>
                <span className="relative inline-block w-full lg:w-[50%]">
                  <input
                    name="rrn_digit"
                    value={formData.rrn_digit}
                    onChange={handleChange}
                    type="text"
                    className="text-white bg-black lg:bg-obsidian text-xs lg:text-sm leading-10 h-10 transition-[0.2s] align-middle block text-center lg:text-left w-full lg:w-[98%] lg:mx-[1%] my-[5px] py-0.5 px-[5px] lg:p-[5px] lg:rounded-[5px] border border-navyBlue lg:border-slate focus:border-skyblue lg:focus:border-indigoBlue outline-none"
                    maxLength="1"
                    placeholder="뒤 1자리"
                  />
                  <span className="absolute text-sm mt-0 right-5 top-[15px]">●●●●●●</span>
                </span>
                <br />
                <small className="text-white lg:text-crimson text-[10px] lg:text-[80%]">
                  - 예시 1) 2025-05-01 - 1 또는 예시 2) 250501 - 1
                </small>
              </div>
            </div>
            <div className="lg:p-2.5 lg:h-[105px]">
              <label
                htmlFor="trading_bank"
                className="mb-[5px] mt-2.5  lg:mb-2.5 lg:m-2.5 block text-[12.9px] lg:text-base text-skyblue lg:text-white "
              >
                {' '}
                거래은행
              </label>
              <div className="">
                <select
                  name="trading_bank"
                  value={formData.trading_bank}
                  onChange={handleChange}
                  id="bk_name"
                  className="text-white bg-black lg:bg-obsidian text-xs lg:text-sm leading-10 h-10 transition-[0.2s] align-middle block text-center lg:text-left w-full lg:w-[98%] lg:mx-[1%] my-[5px] py-0.5 px-[5px] lg:p-[5px] lg:rounded-[5px] border border-navyBlue lg:border-slate focus:border-skyblue lg:focus:border-indigoBlue outline-none"
                >
                  <option value="">선택</option>
                  <option value="토스뱅크">토스뱅크</option>
                  <option value="카카오뱅크">카카오뱅크</option>
                  <option value="국민은행">국민은행</option>
                  <option value="농협중앙">농협중앙</option>
                  <option value="기업은행">기업은행</option>
                  <option value="케이뱅크">케이뱅크</option>
                  <option value="하나은행">하나은행</option>
                  <option value="신한은행">신한은행</option>
                  <option value="새마을금고">새마을금고</option>
                  <option value="우리은행">우리은행</option>
                  <option value="수협은행">수협은행</option>
                  <option value="신협">신협</option>
                  <option value="우체국">우체국</option>
                  <option value="상호저축은행">상호저축은행</option>
                  <option value="SC제일은행">SC제일은행</option>
                  <option value="부산은행">부산은행</option>
                  <option value="광주은행">광주은행</option>
                  <option value="제주은행">제주은행</option>
                  <option value="전북은행">전북은행</option>
                  <option value="경남은행">경남은행</option>
                  <option value="대구은행">대구은행</option>
                  <option value="한국씨티은행">한국씨티은행</option>
                  <option value="산업은행">산업은행</option>
                  <option value="모건스탠리은행">모건스탠리은행</option>
                  <option value="HSBC은행">HSBC은행</option>
                  <option value="도이치은행">도이치은행</option>
                  <option value="제이피모간체이스은행">제이피모간체이스은행</option>
                  <option value="미즈호은행">미즈호은행</option>
                  <option value="엠유에프지은행">엠유에프지은행</option>
                  <option value="BOA은행">BOA은행</option>
                  <option value="비엔피파리바은행">비엔피파리바은행</option>
                  <option value="중국공상은행">중국공상은행</option>
                  <option value="중국은행">중국은행</option>
                  <option value="산림조합중앙회">산림조합중앙회</option>
                  <option value="대화은행">대화은행</option>
                  <option value="교통은행">교통은행</option>
                  <option value="중국건설은행">중국건설은행</option>
                  <option value="삼성증권">삼성증권</option>
                  <option value="하나금융투자">하나금융투자</option>
                  <option value="토스증권">토스증권</option>
                  <option value="카카오페이증권">카카오페이증권</option>
                  <option value="신한금융투자">신한금융투자</option>
                  <option value="한국투자증권">한국투자증권</option>
                  <option value="KB증권">KB증권</option>
                  <option value="미래에셋증권">미래에셋증권</option>
                  <option value="키움증권">키움증권</option>
                  <option value="한화투자증권">한화투자증권</option>
                  <option value="대신증권">대신증권</option>
                  <option value="SK증권">SK증권</option>
                  <option value="현대차증권">현대차증권</option>
                  <option value="하이투자증권">하이투자증권</option>
                  <option value="교보증권">교보증권</option>
                  <option value="NH투자증권">NH투자증권</option>
                  <option value="IBK투자증권">IBK투자증권</option>
                  <option value="BNK투자증권">BNK투자증권</option>
                  <option value="한양증권">한양증권</option>
                  <option value="리딩투자증권">리딩투자증권</option>
                  <option value="유안타증권">유안타증권</option>
                  <option value="상상인증권">상상인증권</option>
                  <option value="다올투자증권">다올투자증권</option>
                  <option value="이베스트투자증권">이베스트투자증권</option>
                  <option value="DB금융투자">DB금융투자</option>
                  <option value="유진투자증권">유진투자증권</option>
                  <option value="메리츠증권">메리츠증권</option>
                  <option value="부국증권">부국증권</option>
                  <option value="신영증권">신영증권</option>
                  <option value="케이프투자증권">케이프투자증권</option>
                  <option value="한국포스증권">한국포스증권</option>
                </select>
              </div>
            </div>
            <div className="lg:p-2.5 lg:h-[105px]">
              <label
                htmlFor="account_number"
                className="mb-[5px] mt-2.5  lg:mb-2.5 lg:m-2.5 block text-[12.9px] lg:text-base text-skyblue lg:text-white "
              >
                {' '}
                계좌번호
              </label>
              <div className="">
                <input
                  name="account_number"
                  value={formData.account_number}
                  onChange={handleChange}
                  type="text"
                  className="text-white bg-black lg:bg-obsidian text-xs lg:text-sm leading-10 h-10 transition-[0.2s] align-middle block text-center lg:text-left w-full lg:w-[98%] lg:mx-[1%] my-[5px] py-0.5 px-[5px] lg:p-[5px] lg:rounded-[5px] border border-navyBlue lg:border-slate focus:border-skyblue lg:focus:border-indigoBlue outline-none"
                  placeholder="계좌번호"
                />
                <small className="text-white text-[10px] lg:hidden">
                  - 본인 명의의 계좌번호를 입력하세요. 이름과 예금주가 다르면 환전되지 않습니다. 수정을 원하시면
                  관리자에게 문의하세요.
                </small>
              </div>
            </div>

            <div className="lg:p-2.5 lg:h-[105px]">
              <label
                htmlFor="mobile_carrier"
                value={formData.mobile_carrier}
                onChange={handleChange}
                className="mb-[5px] mt-2.5  lg:mb-2.5 lg:m-2.5 block text-[12.9px] lg:text-base text-skyblue lg:text-white "
              >
                {' '}
                별명
              </label>
              <div className="">
                <select
                  name="mobile_carrier"
                  value={formData.mobile_carrier}
                  onChange={handleChange}
                  id="agency"
                  className="w-full lg:w-[25%] text-white bg-black lg:bg-obsidian text-xs lg:text-sm leading-10 h-10 transition-[0.2s] align-middle inline-block text-center lg:text-left  lg:mx-[1%] my-[5px] py-0.5 px-[5px] lg:p-[5px] lg:rounded-[5px] border border-navyBlue lg:border-slate focus:border-skyblue lg:focus:border-indigoBlue outline-none"
                >
                  <option value="">통신사선택</option>
                  <option value="SKT">SKT</option>
                  <option value="KT">KT</option>
                  <option value="LGU+">LGU+</option>
                  <option value="SKT 알뜰폰">SKT 알뜰폰</option>
                  <option value="KT 알뜰폰">KT 알뜰폰</option>
                  <option value="LGU+ 알뜰폰">LGU+ 알뜰폰</option>
                </select>

                <input
                  name="phone_number"
                  value={formData.phone_number}
                  onChange={handleChange}
                  type="text"
                  className="w-full lg:w-[40%] text-white bg-black lg:bg-obsidian text-xs lg:text-sm leading-10 h-10 transition-[0.2s] align-middle inline-block text-center lg:text-left lg:mx-[1%] my-[5px] py-0.5 px-[5px] lg:p-[5px] lg:rounded-[5px] border border-navyBlue lg:border-slate focus:border-skyblue lg:focus:border-indigoBlue outline-none"
                  placeholder="핸드폰번호"
                />

                <button
                  type="image"
                  id="btnSendKey"
                  className="w-full lg:w-[25%] bg-[#555] text-white inline-block h-10 align-middle text-[10px] border-none"
                >
                  인증번호요청
                </button>
                <small className="text-white text-[10px] lg:hidden"> ( 숫자만 입력 "-" 제외 )</small>
                <small className="text-white text-[10px] lg:hidden  inline-block">
                  - 수정시에는 관리자에게 요청하세요. 긴급 공지사항 전달 시 휴대폰으로 전송되오니 연락가능한 본인
                  휴대폰번호를 기재해 주세요.
                </small>
              </div>
            </div>
            <div className="lg:p-2.5 lg:h-[105px]">
              <label
                htmlFor="verification_code"
                className="mb-[5px] mt-2.5  lg:mb-2.5 lg:m-2.5 block text-[12.9px] lg:text-base text-skyblue lg:text-white "
              >
                {' '}
                별명
              </label>
              <div className="">
                <input
                  name="verification_code"
                  value={formData.verification_code}
                  onChange={handleChange}
                  id="auth_key"
                  type="text"
                  className="text-white bg-black lg:bg-obsidian text-xs lg:text-sm leading-10 h-10 transition-[0.2s] align-middle block text-center lg:text-left w-full lg:w-[98%] lg:mx-[1%] my-[5px] py-0.5 px-[5px] lg:p-[5px] lg:rounded-[5px] border border-navyBlue lg:border-slate focus:border-skyblue lg:focus:border-indigoBlue outline-none"
                  placeholder="10분이내로 인증번호를 입력"
                />

                <small className="text-white text-[10px] lg:hidden">
                  - 10분이내로 인증번호를 입력하셔야 합니다. ( 24시간내 7번만 인증번호 요청가능 합니다. )
                </small>
                <small className="text-crimson text-[80%]"></small>
              </div>
            </div>
            <div className="lg:p-2.5 lg:h-[105px]">
              <label
                htmlFor="entered_referral_code"
                className="mb-[5px] mt-2.5  lg:mb-2.5 lg:m-2.5 block text-[12.9px] lg:text-base text-skyblue lg:text-white "
              >
                {' '}
                추천코드 <small className="text-crimson text-[80%]">가입코드 없을시 미기재</small>
              </label>
              <div className="">
                <input
                  name="entered_referral_code"
                  value={formData.entered_referral_code}
                  onChange={handleChange}
                  type="text"
                  className="text-white bg-black lg:bg-obsidian text-xs lg:text-sm leading-10 h-10 transition-[0.2s] align-middle block text-center lg:text-left w-full lg:w-[98%] lg:mx-[1%] my-[5px] py-0.5 px-[5px] lg:p-[5px] lg:rounded-[5px] border border-navyBlue lg:border-slate focus:border-skyblue lg:focus:border-indigoBlue outline-none"
                  placeholder="추천코드"
                />
                <small className="text-skyblue text-[10px] lg:hidden">
                  {' '}
                  <b>※ 가입코드 없을 시 미 기재</b>
                </small>
                <small className="text-crimson text-[80%]"></small>
              </div>
            </div>
            <div className="lg:col-span-2 lg:block hidden">
              <div className="mx-auto w-[300px] py-2.5 flex items-center justify-between">
                <button
                  type="button"
                  onClick={handleSubmit}
                  value="회원가입"
                  className="w-[48%] cursor-pointer font-bold transition-[0.5s] h-[50px] leading-[50px] text-white text-sm inline-block bg-blue-glow rounded-[5px] border-solid border-[#0306d4] hover:filter hover:brightness-[1.5] "
                >
                  회원가입
                </button>
                <Link
                  to="/"
                  className="w-[48%] text-center ms-auto cursor-pointer font-bold transition-[0.5s] h-[50px] leading-[50px] text-white text-sm inline-block bg-blue-glow rounded-[5px] border-solid border-[#0306d4] hover:filter hover:brightness-[1.5] "
                >
                  가입취소
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:col-span-2 lg:hidden">
          <div className="mx-auto w-fit py-2.5 flex items-center justify-between">
            <button
              type="button"
              value="회원가입"
              className="w-[150px] h-[46px] leading-[46px] text-[13px] block font-bold text-center transition-[0.3s] text-aquaBlue mb-2.5 mt-2.5  bg-gradient-to-b from-black to-[#0a0000]  border border-[#2f2f2f]  hover:bg-navyBlue  hover:text-skyblue"
            >
              회원가입
            </button>
            &nbsp;
            <Link
              to="/"
              className="w-[150px] h-[46px] leading-[46px] text-[13px] block font-bold text-center transition-[0.3s] text-aquaBlue mb-2.5 mt-2.5  bg-gradient-to-b from-black to-[#0a0000]  border border-[#2f2f2f]  hover:bg-navyBlue  hover:text-skyblue"
            >
              가입취소
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Info;
